import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import pairLogo from "../assets/pair-prog.svg";
import php from "../assets/PHP-logo.webp";
import js from "../assets/javascript-logo.webp";
import c from "../assets/C++Logo.webp";
import py from "../assets/python.webp";
import symfony from "../assets/symfony.webp";
import Jquery from "../assets/JQuery.webp";
import bootstrap from "../assets/Bootstrap.webp";
import html from "../assets/html.webp";
import css from "../assets/CSS.webp";
import git from "../assets/git.webp";
import react from "../assets/React.webp";
import java from "../assets/java.webp";
import sql from "../assets/sql.webp";
import Item from './Item'
import Dot from './Dot'
import TreeSvg from './TreeSvg';
import CodeEditor from './CodeEditor';
import './About.css'
import './Dot.css'


const About = () => {
    const connections = [
        { fromId: 'dot-dut', toId: 'dot-sapli', colorFrom: '#fff', colorTo: '#9b87f5' },
        { fromId: 'dot-lot', toId: 'dot-appligos', colorFrom: '#9b87f5', colorTo: '#fff' },
    ];

    return (
        <div className="about-container">
            <Row>
                <Col className='tree' xs={12} md={3}>
                    <TreeSvg connections={connections} />
                    <Dot id="dot-git" title="Git init" desc="First commit" date="00"/>
                    <Dot id="dot-sti2d" title="Baccalauréat STI2D SIN" desc="Lycée Jean François Champollion" date="00"/>
                    <Dot id="dot-dut" title="DUT - Informatique" desc="Paul sabatier" date="00"/>
                    
                    <div className='branch'>
                        <div className='sketch'>
                            <span className='line'></span>
                        </div>
                        <div className='branch-dots'>
                            <Dot id="dot-sapli" title="SAPLI" desc="&emsp;Co-fondateur d'une association à vocation éducative, œuvrant à faciliter l'accès aux stages et à concevoir des projets pédagogiques adaptés aux besoins des étudiants." date="00" variant="branch"/>
                            <Dot id="dot-lot" title="Département du Lot" desc={<>Developpeur polyvalent <br/><br/> &emsp;Conception et développement de solutions visant à simplifier le quotidien des agents au sein de l'entité.</>} date="00" variant="branch"/>
                        </div>
                    </div>
                    <Dot id="dot-appligos" title="Appligos - OpenDev" desc={<>Developpeur Full Stack<br/><br/>&emsp;Conception et développement d’une application web (Symfony) dédiée au partage de transports de patients. Gestion complète du projet en autonomie : analyse des besoins, conception de la base de données, développement et mise en production.</>} date="00"/>
                    <Dot id="dot-freelance" title="Free Lance" desc={<>&emsp;Conception et développement de solutions web sur mesure, à destination des particuliers et des professionnels : sites vitrines, applications métier et interfaces utilisateur.</>} date="00"/>
                    <Dot id="dot-vous" title="Pourquoi pas vous ?" desc="Devenez mon prochain commit !" date="00"/>
                </Col>
                <Col xs={12} md={6}>
                    <CodeEditor />
                </Col>
            </Row>
            <Row className='p-0'>
                <h2 className='text-light d-flex justify-content-center'>Mes outils</h2>
            </Row>
            <Row className='outils justify-content-center'>
                <Item title="PHP" imageUrl={php} redirectUrl=""/>
                <Item title="GIT" imageUrl={git} redirectUrl=""/>
                <Item title="JavaScript" imageUrl={js} redirectUrl=""/>
                <Item title="CSS" imageUrl={css} redirectUrl=""/>
                <Item title="React js" imageUrl={react} redirectUrl=""/>
                <Item title="Python" imageUrl={py} redirectUrl=""/>
                <Item title="HTML" imageUrl={html} redirectUrl=""/>
                <Item title="Java" imageUrl={java} redirectUrl=""/>
                <Item title="C++" imageUrl={c} redirectUrl=""/>
                <Item title="Bootstrap" imageUrl={bootstrap} redirectUrl=""/>
                <Item title="PL/SQL" imageUrl={sql} redirectUrl=""/>
                <Item title="Symfony" imageUrl={symfony} redirectUrl=""/>
                <Item title="JQuery" imageUrl={Jquery} redirectUrl=""/>
            </Row>
            <Row className='about-row'>
                <h2 className='text-light d-flex justify-content-center'>Plus sur moi</h2>
            </Row>
            <Row className='p-0'>
                <Col className='about-me-text' xs={12} md={5}>
                    <p>
                        &emsp;Je m'appelle Théo Pellefigue. Je suis titulaire d'un baccalauréat STI2D option SIN du lycée Jean François Champollion de Figeac,
                        ainsi que d'un DUT Informatique de l'IUT Paul Sabatier de Toulouse.
                        <br/>
                        <br/>
                        &emsp;J'ai eu l'opportunité de travailler chez Appligos-OpenDev pendant deux ans et demi en tant que développeur FullStack Symfony.
                        <br/>
                        <br/>
                        &emsp;Je suis également cofondateur d'une association qui aide les jeunes développeurs à acquérir de l'expérience en leur confiant des projets et des responsabilités.
                    </p>
                </Col>
                <Col xs={4}>
                    <img src={pairLogo} alt="pair" className='pair' />
                </Col>
            </Row>
        </div>
    );
};

export default About;